<template>
  <td ref="cell" class="td vs-table--td" :class="{ 'td-edit': hasEditSlot }">
    <span @click="clickCell">
      <vs-icon v-if="hasEditSlot" class="icon-edit" icon="edit" />
      <slot />
      <span v-if="hasEditSlot" class="empty">{{ data ? "" : "Empty" }}</span>
    </span>
  </td>
</template>

<script>
export default {
  name: "VsTd",
  inject: {
    vsTableRow: {
      default: null,
    },
  },
  props: {
    data: {
      default: null,
    },
  },
  computed: {
    hasEditSlot() {
      return Boolean(this.$slots.edit);
    },
  },
  methods: {
    clickCell() {
      if (this.hasEditSlot && this.vsTableRow) {
        this.vsTableRow.openEdit(this.$slots.edit);
      }
    },
    close() {
      if (this.vsTableRow) this.vsTableRow.closeEdit();
    },
    saveEdit() {
      this.close();
    },
  },
};
</script>
